// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qi_a bhi_su bhi_kv bhi_kw","PostDetailRight__brandDaysPosts":"qi_b bhi_su bhi_kv bhi_kw"};